export default {
  status: {
    11: 'rest',
    12: 'rest',
    21: 'lunch',
    22: 'lunch',
    31: 'after',
    32: 'after'
  }
}
